import React, { Fragment, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PrintTwoToneIcon from '@mui/icons-material/PrintTwoTone'
import { CrackInjectionPrintable, DowelingPrintable } from './components'
import { Button, PrintWrapper } from '../../../../components'
import { useReactToPrint } from 'react-to-print'
import { cancelPrintAction, printAction } from '../../../../utils/actions'
import { appConfig } from '../../common/constants'

const PrintView = () => {
  const printRef = useRef()
  const dispatch = useDispatch()

  const { input, status } = useSelector((state) => state.calculation)
  const { isLoading, isError } = useSelector((state) => state.staticData.status)

  const isValid =
    !status.isLoading && !status.isError && status.msgLevel !== 'error' && !isLoading && !isError

  const Printable = {
    0: DowelingPrintable,
    1: CrackInjectionPrintable,
  }

  const handlePrintAction = useReactToPrint({
    documentTitle: appConfig.appName,
    content: () => printRef.current,
    onBeforeGetContent: async () => {
      dispatch(printAction())
    },
    onAfterPrint: () => {
      dispatch(cancelPrintAction())
    },
  })

  return (
    <Fragment>
      <Button
        variant="topNav"
        className="button topNav__button"
        onClick={handlePrintAction}
        disabled={!isValid}
      >
        <PrintTwoToneIcon className="material-icons-two-tone material-icons-two-tone--noinvert" />
        <span className="button__text">Print</span>
      </Button>
      <PrintWrapper ref={printRef}>
        <div className="print-header">
          <div className="appBrandingGroup">
            <img data-src={appConfig.logoUrl} className="iconic injectSVG appLogo" alt="TBD Logo" />
            <div className="aboutAppHeading">
              <div className="aboutAppAcronym">
                <span className="aboutAppAcronym__label"></span>
                {appConfig.appCode}
              </div>
              <div className="aboutAppFullName">{appConfig.appName}</div>
            </div>
          </div>
        </div>
        <div className="print-body">
          {!isLoading && !isError && (
            <section className="print-modal">
              {React.createElement(Printable[input.subApp])}
            </section>
          )}
        </div>
      </PrintWrapper>
    </Fragment>
  )
}

export default PrintView
